import IPCustomCheckbox from './IPCustomCheckbox'

export default IPCustomCheckbox
